import { FormActionType } from '@/types/shared';
import cx from 'classnames';
import Link from '../Link';
import { DesktopMenuLink } from './Header.types';
import { isValidActionType } from './Header.utils';
import { MobileMenuTrigger } from './MobileMenuTrigger';

type RightMenuColumnProps = {
  desktopMenuLinks: DesktopMenuLink[];
  invert?: boolean;
  isHeaderScrolled: boolean;
  onCloseAllMenus: () => void;
  onClickMenuButton: (action: FormActionType) => void;
  isMobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
}

export const RightMenuColumn = ({ desktopMenuLinks, invert, isHeaderScrolled, onCloseAllMenus, onClickMenuButton, isMobileMenuOpen, onToggleMobileMenu }: RightMenuColumnProps) =>
  <ul className="lg:col-span-6 2xl:col-span-3 flex gap-1 justify-end items-center whitespace-nowrap">
    {desktopMenuLinks.map(({ type, title, href, action }, index) => {
      return (
        <li
          key={`header-desktop-menu-link-${title?.replace(/\s/g, '-') ?? index}`}
          className="hidden lg:block"
        >
          {href.length ? (
            <Link
              className={cx('block button button-size-medium', {
                'button-primary-link-header': type === 'link' && (!invert || isHeaderScrolled),
                'button-primary-link-header-invert': type === 'link' && invert && !isHeaderScrolled,

                'button-primary-violet': type === 'primary' && (!invert || isHeaderScrolled),
                'button-primary-white': type === 'primary' && invert && !isHeaderScrolled,

                'button-secondary-gray': type === 'secondary' && (!invert || isHeaderScrolled),
                'button-secondary-violet-300': type === 'secondary' && invert && !isHeaderScrolled,
              })}
              href={href}
              onClick={onCloseAllMenus}
            >
              {title}
            </Link>
          ) : (
            <button
              className={cx('block', {
                'text-16/16 px-2 font-500': type === 'link',
                'text-white': type === 'link' && invert && !isHeaderScrolled,
                'button button-size-medium': type === 'primary' || type === 'secondary',
                'button-primary-violet': type === 'primary' && (!invert || isHeaderScrolled),
                'button-primary-white': type === 'primary' && invert && !isHeaderScrolled,
                'button-secondary-gray': type === 'secondary' && (!invert || isHeaderScrolled),
                'button-secondary-violet-300': type === 'secondary' && invert && !isHeaderScrolled,
              })}
              onClick={() => {
                if (!isValidActionType(action)) return;
                onClickMenuButton(action);
              }}
            >
              {title}
            </button>
          )}
        </li>
      );
    })}
    <li className="lg:hidden">
      <MobileMenuTrigger isMobileMenuOpen={isMobileMenuOpen} onToggleMobileMenu={onToggleMobileMenu} />
    </li>
  </ul>
